export interface IAppEventHandler<T> {
    (sender: any, data: T);
}

export interface IAppEvent<T> {

    add<THandler extends IAppEventHandler<T>>(handler: THandler): THandler;

    remove(handler: IAppEventHandler<T>): void;
}

/****************************************/

export class AppEvent<T> implements IAppEvent<T> {

    private _handlers: IAppEventHandler<T>[];
    private readonly _awaitHandler;

    constructor(awaitHandler = false) {
        if (awaitHandler)
            this._awaitHandler = true;
    }

    add<THandler extends IAppEventHandler<T>>(handler: THandler): THandler {

        if (!this._handlers)
            this._handlers = [];

        if (this._handlers.indexOf(handler) == -1)
            this._handlers.push(handler);

        return handler;
    }

    remove(handler: IAppEventHandler<T>): void {

        if (this._handlers) {
            const index = this._handlers.indexOf(handler);
            if (index != -1)
                this._handlers.splice(index, 1);
        }
    }

    async raise(sender: any, data?: T) {

        if (this._handlers) {
            for (const handler of this._handlers) {
                const result = handler(sender, data);
                if (this._awaitHandler && result instanceof Promise)
                    await result;
            }
        }
    }

    get hasHandlers() { return this._handlers?.length > 0 };
}

/****************************************/

export function event<T>(awaitHandler = false): AppEvent<T> {

    return new AppEvent<T>(awaitHandler);
}